<template>
  <div class="w-100">
    <div class="w-100 my-2 p-2 text-left bg-light">
      <button class="btn btn-outline-success btn-sm" @click="discountManage()">新增</button>
      <button class="btn btn-outline-primary btn-sm ml-2">搜尋</button>
      <button class="btn btn-outline-warning btn-sm ml-2">清除搜尋條件</button>
    </div>

    <div class="w-100 d-flex align-items-center" v-for="(list, index) in cartDiscountList"
      :key="'cart__discount__' + index">
      <table class="table table-bordered table-sm my__table">
        <colgroup>
          <col style="min-width: 100px; width: 100px">
          <col style="min-width: 300px; width: 300px">
          <col>
        </colgroup>
        <tr>
          <td class="my__table__td" rowspan="2">
            <div class="d-flex align-items-center justify-content-around">
              <span>{{index + 1}}</span>
              <button class="btn btn-sm btn-primary" @click="discountManage(list.uid)">修改</button>
            </div>
          </td>
          <td>
            <div>折扣區名稱</div>
            <div>{{ list.name }}</div>
          </td>
          <td class="my__table__td">
            <div class="d-flex align-items-center">
              <button class="btn btn-sm btn-primary">預覽文宣</button>
              <span class="text-primary">
                <small>{{ getFrontContextShow(list.frontWebShow) }}</small>
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="my__table__td">
            <div class="d-flex align-items-center">
              <button class="btn btn-outline-secondary btn-sm">選擇商品</button>
              <div class="flex-fill d-flex flex-column align-items-center">
                <span>共2筆</span>
                <span>（結束販賣中）</span>
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <span>本區買滿件／額度折扣：</span>
              <div class="d-flex">
                <span class="my__tag text-white"
                  :class="'bg-' + (list.discountMix ? 'success' : 'danger')">{{list.discountMix ? '可混搭' : '不可混搭'}}</span>
              </div>
            </div>

            <ul class="my__table__example__list">
              <li>
                {{getDiscountState(list.totalThenDiscount, list.anyThenDiscount)}}
              </li>
              <li>
                使用期限：<span
                  :class="getUseTime(list.time).color">{{ getUseTime(list.time).text }}</span>
              </li>
              <li>
                購物車顯示內容：<span
                  :class="getCartShowInfor(list).color">{{ getCartShowInfor(list).text }}</span>
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';

  export default {
    data() {
      return {
        today: this.$moment()
      }
    },
    methods: {
      discountManage(uid = 'insert') {
        this.$router.push({
          name: "discountSetting",
          params: {
            uid: uid
          }
        });
      },
    },
    computed: {
      cartDiscountList: {
        get() {
          return this.$store.state.cart.cartDiscountList;
        },
      },

      getFrontContextShow() {
        return (data) => {
          if (data) {
            return '（顯示）';
          }
          return '（不顯示）';
        }
      },

      getUseTime() {
        return (time) => {
          let start = time.startTime;
          let end = time.endTime;
          let text = "無使用期限";

          if (start == "0000-00-00 00:00:00" && end == "0000-00-00 00:00:00") {
            return {
              text: text,
              color: ""
            };
          }

          let startSwitch = (this.$moment(start) < this.today);
          let endSwitch = (this.$moment(end) > this.today);

          if (startSwitch && endSwitch) {
            text = "開始時間：" + this.$moment(start).format("YYYY/MM/DD hh:mm") + "結束時間：" + this
              .$moment(end).format("YYYY/MM/DD hh:mm");
            return {
              text: text,
              color: ""
            }
          } else if (!startSwitch && !endSwitch) {
            text = "非使用期間，開始時間：" + this.$moment(start).format("YYYY/MM/DD hh:mm");
            return {
              text: text,
              color: "text-success"
            }
          } else if (!startSwitch && endSwitch) {
            text = "使用中，結束時間：" + this.$moment(end).format("YYYY/MM/DD hh:mm");;
            return {
              text: text,
              color: "text-success"
            }
          } else {
            text = "非使用期間";
            return {
              text: text,
              color: "text-danger"
            }
          }
        }
      },

      getCartShowInfor() {
        return (list) => {
          let purchase = ((list.frontAddPurchaseShow) ? "顯示" : "不顯示") + "加購區商品";
          let payFull = ((list.frontFullShow) ? "顯示" : "不顯示") + "相關商品";

          if (list.limitModel == "addPurchase") {
            return {
              text: purchase,
              color: (list.frontAddPurchaseShow) ? "text-success" : "text-danger"
            }
          } else if (list.limitModel == "payFull") {
            return {
              text: payFull,
              color: (list.frontFullShow) ? "text-success" : "text-danger"
            }
          } else {
            return {
              text: payFull + "，" + purchase,
              color: (list.frontFullShow) ? "text-success" : "text-danger"
            }
          }

          return {
            text: "未設定",
            color: "text-danger"
          };
        }
      },

      getDiscountState() {
        return (total, any) => {
          let text = "邏輯尚未完成";
          return text;
        }
      }
    },

    created() {
      this.$store.dispatch("cart/getCartDiscountList");
    }
  };

</script>

<style></style>
